/**
 * Full-page "Connected Tools (MCP)" (`/agent/:slug/mcp`) — Maximus's
 * bring-your-own MCP servers, relocated off the Account page. Console chrome
 * applies automatically (`/agent/…` route). Gated like the MCP surface itself:
 * the MCP agent (Maximus) + beta-stage + admin — anyone else is bounced.
 */
import { Link, Navigate, useParams } from 'react-router-dom';
import { AGENTS } from '../../agents/registry.ts';
import { canUseMcpSettings, MCP_AGENT_SLUG } from '../../agents/mcpApi.ts';
import { useAuth } from '../../auth/useAuth.ts';
import McpServersManager from '../../components/console/McpServersManager.tsx';
import './MaximusMcpPage.css';

export default function MaximusMcpPage() {
  const { slug } = useParams<{ slug: string }>();
  const { user } = useAuth();

  if (slug !== MCP_AGENT_SLUG || !canUseMcpSettings(user)) {
    return <Navigate to="/app" replace />;
  }
  const agent = AGENTS[MCP_AGENT_SLUG];

  return (
    <div className="om-mcppage">
      <div className="om-mcppage__inner">
        <Link to={`/agent/${slug}`} className="om-mcppage__back">
          ← {agent.name} console
        </Link>
        <h1 className="om-mcppage__title">Connected Tools (MCP)</h1>
        <p className="om-mcppage__hint">
          Connect your own MCP (Model Context Protocol) servers and {agent.name} can use their tools
          on your behalf. Tokens are stored securely and never shown again.
        </p>
        <McpServersManager />
      </div>
    </div>
  );
}
